import React, { useEffect, useState } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import Box from "@material-ui/core/Box";
import { useParams } from "react-router-dom";
import LoadingPaper from "../LoadingPaper/LoadingPaper.jsx";
import PropertiesList from "../PropertiesList/PropertiesList.jsx";
import SaveIcon from "@material-ui/icons/Save";
import BeenhereIcon from "@material-ui/icons/Beenhere";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import BarChartIcon from "@material-ui/icons/BarChart";
import PropTypes from "prop-types";
import RelationsList from "../RelationsList/RelationsList.jsx";
import CopyLinkButton from "../Views/help/CopyLinkButton.jsx";
import axios from "axios";
import moment from "moment";

import {
    editButtonTheme as back,
    toggleButtonTheme as submit,
} from "../../config/theme";
import { filterForEdit } from "../../lib/helperFuncs.jsx";

// import { api_key } from "../../config/client";

const EditForm = (props) => {
    const MUTABLE = true;
    const { id } = useParams();

    useEffect(() => {
        props.initAction(id);
        if (props?.getPlacesSale) {
            props.getPlacesSale();
        }
    }, []);

    const [linkShop, setLinkShop] = useState(false);
    const {
        fields,
        item,
        fieldUpdateHandler,
        errorFields,
        relations,
        relationsDataSource,
        defaultPaymentTypes,
        defaultServices,
        serviceCategories,
        defaultValues,
        updateImage,
        defaultRoomFeatures,
        defaultRoomTypes,
        updateCurRateFromBase,
        allItems,
        inheritStarted,
        unusedServicesHidden,
        defaultRates,
        cancellationPolicy,
        defaultHotels,
        placesSale,
        interfaceTypes,
        thisRates,
        defaultDiscountTypes,
        thisConfiguration,
        imageAcceptExtensions,
        hotelId,
        disclaimer,
    } = { ...props };

    const [rates, setRates] = useState([]);
    const [updateRates, setUpdateRates] = useState(false);

    useEffect(() => {
        if (props?.thisRates) {
            axios
                .get(`/manager/data/hotels/${hotelId}/get_rates_for_inherit`)
                .then((res) => {
                    setRates(
                        res.data.filter(
                            (r) =>
                                r.active &&
                                r.id !== item?.id &&
                                !r.inherited &&
                                moment(r.date_end, "YYYY-MM-DD").isAfter(
                                    moment(),
                                ),
                        ),
                    );
                });
        }
    }, [updateRates, props?.thisRates]);

    const buttons = [
        {
            type: back,
            icon: <ArrowBackIcon />,
            caption: "Вернуться",
            link: props.getBackLink(),
        },
        {
            type: submit,
            icon: <SaveIcon />,
            caption: "Сохранить",
            action: props.submitAction,
        },
        {
            type: submit,
            icon: <BeenhereIcon />,
            caption: "Применить",
            action: props.submitActionApply,
        },
    ];

    const addPeriodPrice = () => {
        if (!item?.id) {
            return;
        }
        axios
            .get("/manager/data/hotels/add_period_price/" + item.id)
            .then((response) => {
                alert(response?.data);
            })
            .catch((error) => console.error(error));
    };

    if (props?.thisRates) {
        buttons.push({
            type: submit,
            icon: <BarChartIcon />,
            caption: "Добавить уровень цен",
            action: addPeriodPrice,
            color: "#799399",
        });
    }
    const layoutFields = props?.thisCompany ? fields : filterForEdit(fields);

    const redBoxStyle = {
        color: "red",
        border: "1px solid red",
        padding: "4px",
        marginLeft: "8px",
    };

    useEffect(() => {
        if (item && thisRates && item?.hotel_id) {
            axios
                .get("/manager/data/hotels_link/" + item?.hotel_id)
                .then((response) => {
                    if (response.data.length < 5)
                        alert(
                            "В отеле ID = " +
                                item.hotel_id +
                                " не корректно заполнен адрес сайта!",
                        );
                    else {
                        const currentDate = moment().format("YYYY-MM-DD");
                        const itemDateStart = moment(props?.item?.date_start);
                        const minStay = props?.item?.min_stay ?? 1;

                        const maxDate = props?.item?.date_end;
                        const minDate = props?.item?.date_start;

                        let date, dateOut;
                        if (currentDate < itemDateStart.format("YYYY-MM-DD")) {
                            date = itemDateStart.format("YYYY-MM-DD");
                            dateOut = itemDateStart
                                .add(minStay, "days")
                                .format("YYYY-MM-DD");
                        } else {
                            date = currentDate;
                            dateOut = moment(currentDate)
                                .add(minStay, "days")
                                .format("YYYY-MM-DD");
                        }
                        setLinkShop(
                            response.data +
                                "?rate_id=" +
                                item.id +
                                "&date=" +
                                date +
                                "&date_out=" +
                                dateOut +
                                "&min_date=" +
                                minDate +
                                "&max_date=" +
                                maxDate +
                                "&min_stay=" +
                                minStay,
                        );
                    }
                })
                .catch((error) => alert(error.response.data.message));
        }
    }, [item]);

    return !item || props.loading ? (
        <Paper elevation={3}>
            <LoadingPaper />
        </Paper>
    ) : (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {props?.thisPurchasedServices
                        ? `${props.title} ${props.item.id}`
                        : thisConfiguration
                          ? `${props.title} ${props.item.key}`
                          : `${props.title} ${props.item.name}`}
                </Typography>
                {disclaimer && (
                    <Box mt={1}>
                        <Typography
                            variant="body2"
                            color="error"
                            style={{ fontStyle: "italic" }}
                        >
                            {disclaimer}
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box pt={4} pb={4}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ControlButtons items={buttons} />
                    {props.item?.before_rate_need && (
                        <div style={redBoxStyle}>Начало не скомбинировано</div>
                    )}
                    {props.item?.after_rate_need && (
                        <div style={redBoxStyle}>
                            Окончание не скомбинировано
                        </div>
                    )}
                </div>
            </Box>
            {thisRates && item && (
                <div>{linkShop && <CopyLinkButton link={linkShop} />}</div>
            )}
            <Box mt={4}>
                <form>
                    <PropertiesList
                        fields={layoutFields}
                        mutable={MUTABLE}
                        item={item}
                        fieldUpdateHandler={fieldUpdateHandler}
                        errorFields={errorFields}
                        relationsDataSource={relationsDataSource}
                        defaultPaymentTypes={defaultPaymentTypes}
                        defaultServices={defaultServices}
                        serviceCategories={serviceCategories}
                        defaultValues={defaultValues}
                        updateImage={updateImage}
                        defaultRoomFeatures={defaultRoomFeatures}
                        defaultRates={defaultRates}
                        cancellationPolicy={cancellationPolicy}
                        defaultHotels={defaultHotels}
                        placesSale={placesSale}
                        interfaceTypes={interfaceTypes}
                        defaultDiscountTypes={defaultDiscountTypes}
                        defaultRoomTypes={defaultRoomTypes}
                        updateCurRateFromBase={updateCurRateFromBase}
                        allItems={allItems}
                        inheritStarted={inheritStarted}
                        unusedServicesHidden={unusedServicesHidden}
                        thisFeatures={props.thisFeatures}
                        payment_methods={props.payment_methods}
                        imageAcceptExtensions={imageAcceptExtensions}
                        rates={rates}
                        setUpdateRates={setUpdateRates}
                        thisPurchasedServices={props.thisPurchasedServices}
                        thisRoomType={props.thisRoomType}
                        thisInterface={props.thisInterface}
                        thisCancellationPolicy={props?.thisCancellationPolicy}
                        hotelId={hotelId}
                    />
                </form>
            </Box>
            {relations && (
                <RelationsList
                    relations={relations}
                    relationsDataSource={relationsDataSource}
                    id={item.id}
                />
            )}
            <Box pt={4} pb={4}>
                {<ControlButtons items={buttons} />}
            </Box>
        </Paper>
    );
};

EditForm.defaultProps = {
    loading: true,
    title: "Редактируем объект",
};

EditForm.propTypes = {
    title: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    fields: PropTypes.object,
    item: PropTypes.object,
    errorFields: PropTypes.object,
    initAction: PropTypes.func.isRequired,
    submitAction: PropTypes.func.isRequired,
    fieldUpdateHandler: PropTypes.func.isRequired,
    getBackLink: PropTypes.func.isRequired,
    relations: PropTypes.object,
    relationsDataSource: PropTypes.func,
    getDefaultValues: PropTypes.func,
    defaultPaymentTypes: PropTypes.array,
    defaultServices: PropTypes.array,
    serviceCategories: PropTypes.array,
    defaultValues: PropTypes.array,
    loadedPaymentTypes: PropTypes.bool,
    loadedServices: PropTypes.bool,
    updateCategoryImage: PropTypes.func,
    updateCurRateFromBase: PropTypes.func,
    allItems: PropTypes.array,
    unusedServicesHidden: PropTypes.object,
};

export default EditForm;
